import { WorkspaceRepository } from '@telespot/domain';

export interface ICountWorkspacesByCaseTypeQuery {
  /**
   * Counts workspaces that adopt the given case type.
   * Repository errors propagate so the caller can update its error state.
   */
  execute(caseTypeId: string): Promise<number>;
}

export class CountWorkspacesByCaseTypeQuery implements ICountWorkspacesByCaseTypeQuery {
  constructor(private readonly workspaceRepository: WorkspaceRepository) {}

  public async execute(caseTypeId: string): Promise<number> {
    return this.workspaceRepository.countByCaseType(caseTypeId);
  }
}
